"use strict"
exports.__esModule = true;
exports.FolderOpenAltIconConfig = {
  name: 'FolderOpenAltIcon',
  height: 1024,
  width: 1217,
  svgPath: 'M1199.6,520.6 C1187.8,514.9 1174.4,512 1159.3,512 L412.7,512 C288.5,512 236.7,593.1 236.7,593.1 L75.6,810.6 L150,552.2 C162,520.1 187.3,492.8 225.6,470.4 C263.9,448 304.1,448 345.8,448 L1089,448 L1089,256 C1089,256 1089,192 1025,192 L503.3,192 L470.6,130.1 C470.6,130.1 440,64 374.7,64 L65,64 C1,64 1,128 1,128 L1,960 L807.7,960 C837,960 868.9,952.166667 903.4,936.5 C937.9,920.8 964.6,901.5 983.7,879 L1196.4,593.2 C1210.2,577.7 1217,561.41 1217,549.3 C1217,537.19 1211.3,526.3 1199.6,520.6',
  yOffset: 0,
  xOffset: 0,
};
exports.FolderOpenAltIcon = require('../createIcon').createIcon(exports.FolderOpenAltIconConfig);
exports["default"] = exports.FolderOpenAltIcon;